import React, {Component} from 'react'
import PostTheAmoun from './PostTheAmoun.jsx'
import TrafficCard from './TrafficCard.jsx'

class MyDeskGraphCard extends Component {
    render() {
        return <div className='myDeskGraphCard'>
            <PostTheAmoun></PostTheAmoun>
            <TrafficCard></TrafficCard>
        </div>
    }
}

export default MyDeskGraphCard;